const pdate = require('pdate')

const farsi = require('./farsi.ts').makeNumbersFarsi

export const toPersianDateTime = (date: any, delimiter?: any) => {
  let output = toPersianDate(date, delimiter)
  date = parseDate(date)
  output += ' ' + date.getHours() + ':' + date.getMinutes()
  return farsi(output)
}

export const toPersianDate = (date: any, delimiter?: any) => {
  delimiter = delimiter || '-'
  let pd = pdate.fromDate(parseDate(date))
  let lrm = String.fromCharCode(8206)
  return farsi(
    `${pd.year}${lrm}${delimiter}${pd.month}${lrm}${delimiter}${pd.day}`,
  )
}

function parseDate(dateString: any) {
  return new Date(Date.parse(dateString))
}
